/**
 * Module dependencies.
 */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { appRoutes } from 'app/routes';
import { compileMenu } from 'app/core/utils/menu';
import { Dashboard } from './dashboard';
import { Coins, FlaskConical, Flag, Users } from 'lucide-react';

/**
 * Export `SkinAdministration` component.
 */

export function SkinAdministration(): JSX.Element {
  const [translate] = useTranslation();
  const items = useMemo(
    () =>
      compileMenu([
        {
          key: '1',
          pathname: appRoutes.dashboard.administration.base,
          icon: <Users />,
          label: translate('administration.menu.users')
        },
        {
          key: '2',
          pathname: appRoutes.dashboard.administration.featureFlags,
          icon: <Flag />,
          label: translate('administration.menu.featureFlags')
        },
        {
          key: '3',
          pathname: appRoutes.dashboard.administration.stablecoins,
          icon: <Coins />,
          label: translate('administration.menu.stablecoins')
        },
        {
          key: '4',
          pathname: appRoutes.dashboard.administration.development,
          icon: <FlaskConical />,
          label: translate('administration.menu.development')
        }
      ]),
    [translate]
  );

  return (
    <Dashboard menu={items}>
      <Outlet />
    </Dashboard>
  );
}
